import React from 'react';
import './App.css';
import Sidebar from './components/sidebar/Sidebar';
import Home from './components/home/Home';
import About from './components/about/About';
import Services from './components/services/Services';
import Pricing from './components/pricing/Pricing';
import Contact from './components/contact/Contact';
import Testimonials from './components/testimonials/Testimonials';


function App() {
  return (
    <>
      <Sidebar />
      <main className='main'>
        <Home />
        <About />
        <Services />
        <Pricing />
        <Testimonials />
        <Contact />
      </main>

    </>
  );
}

export default App;
